module.exports = __webpack_public_path__ + "img/wf.86cc3136.svg";